(() => {
  let target = '[data-animate]';

  let observerOptions = {
    rootMargin: "0px",
    threshold: 0.1
  }

  var observer = new IntersectionObserver(observerCallback, observerOptions);

  function observerCallback(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
          entry.target.style.setProperty('--anim-play-state', 'running');
      }
    });
  };

  document.querySelectorAll(target).forEach((el) => {
    observer.observe(el)
  });
})();
